import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/invoice.js';
export const UpdateInvoicePathRequestSchema = z.object({});
export const UpdateInvoiceApiSchema = {
    body: InvoiceSchema.pick({ total: true, customer: true }),
    params: z.object({
        entityId: CornSchema,
        invoiceId: z.string(),
    }),
    headers: z.object({ requestActor: z.string() }),
    response: InvoiceSchema.optional(),
};
export const UpdateInvoicePathSchema = UpdateInvoiceApiSchema.params;
export const UpdateInvoiceHeadersSchema = UpdateInvoiceApiSchema.headers;
export const UpdateInvoiceRequestSchema = UpdateInvoiceApiSchema.body
    .merge(UpdateInvoiceHeadersSchema)
    .merge(UpdateInvoicePathSchema);
export const UpdateInvoiceInternalRequestSchema = UpdateInvoiceRequestSchema;
export const UpdateInvoiceResponseSchema = UpdateInvoiceApiSchema.response;
